import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Gets the ORGs for the manage page together with the CC app ids
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get the list
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken'];
  const paramsRules = { accessToken: { allowedTypes: ['string'] } };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${settings.endpoint}/appsinfo?api_key=${settings.apiKey}`, {
    signal,
    headers: { Authorization: params.accessToken },
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content.orgs;
  }
};
